import accountsSlice from 'features/home/services/Accounts/AccountsSlice';
import userSlice from 'features/userPage/services/UserInfo/UserSlice';

const globalReducer = {
  accountsReducer: accountsSlice,
  userReducer: userSlice,
};

export default globalReducer;
